import axiosClient from "../../../../../../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/hr-epic-view-summary-draft/${id}`)

    return result.data
}
